import { FormProvider, useForm } from 'react-hook-form';
import styled from 'styled-components';

import LoadingView from '@/components/common/LoadingView';
import { useGetForeignCurrencyHistory } from '@/hooks/useGetForeignCurrencyHistory';
import FXReceiptItem from './FXReceiptItem';
import PagingWithLastPage from '../common/PagingWithLastPage';
import { FX_RECEIPT_HEADER } from '@/constants/fxReceipt';
import FXTableHeader from './FXTableHeader';

function FXReceiptList() {
  const {
    foreignCurrencies,
    totalPage,
    pageNumber,
    setPageNumber,
    isLoading,
    status,
    setStatus,
  } = useGetForeignCurrencyHistory();
  const methods = useForm({
    defaultValues: {
      checked: false,
    },
  });

  return (
    <FormProvider {...methods}>
      {isLoading ? (
        <LoadingView height='80vh' />
      ) : (
        <>
          {foreignCurrencies && foreignCurrencies.content.length > 0 ? (
            <Table>
              <FXTableHeader
                titleList={FX_RECEIPT_HEADER}
                status={status}
                setStatus={setStatus}
                setPageNumber={setPageNumber}
              />
              <tbody>
                {foreignCurrencies.content.map((foreignCurrency, index) => (
                  <FXReceiptItem
                    key={foreignCurrency.foreignCurrencyId}
                    foreignCurrency={foreignCurrency}
                    index={index}
                    currentPage={foreignCurrencies.number}
                  />
                ))}
              </tbody>
            </Table>
          ) : (
            <PaymentNotContainer>수납 내역이 없습니다</PaymentNotContainer>
          )}
        </>
      )}
      <PagingWithLastPage
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        totalPage={totalPage}
      />
    </FormProvider>
  );
}

export default FXReceiptList;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
  background-color: ${(props) => props.theme.pointColors.white};
  border-radius: 16px;
  overflow: hidden;
`;

const PaymentNotContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 708px;
  flex: 1;
  background-color: #fff;
  border-radius: 16px;

  color: var(--Mono-50, #80848a);
  text-align: center;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;
